export const AUTH_TOKEN = '__DESPERTA_PARTNER_TOKEN__'
export * from './uf'
export * from './banks'
